import { render, staticRenderFns } from "./ClientManagment.vue?vue&type=template&id=d6d9ca14&scoped=true&"
import script from "./ClientManagment.vue?vue&type=script&lang=ts&"
export * from "./ClientManagment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d9ca14",
  null
  
)

export default component.exports